import { INICIALIZAR } from '../actions';
export default function configVideos() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case INICIALIZAR:
      return action.config.configVideos;

    default:
      return state;
  }
}